import { BlockHeading as ConcordeBlockHeading } from '@epilot/concorde-elements'
import { H5, H6, Typography, makeStyles } from '@epilot/journey-elements'
import type { PropsWithChildren } from 'react'

import { useIsMobileOrTablet } from '../../utils/helper'

type BlockHeadingProps = {
  title?: string
  subtitle?: string
  useNewDesign?: boolean
  isGroup?: boolean
  required?: boolean
}

export function BlockHeading({
  title,
  subtitle,
  children,
  useNewDesign,
  isGroup,
  required
}: PropsWithChildren<BlockHeadingProps>) {
  const classes = useStyles()

  const mobile = useIsMobileOrTablet()

  if (!title && !subtitle) {
    return <>{children}</>
  }

  if (useNewDesign) {
    return (
      <ConcordeBlockHeading
        isGroup={isGroup}
        required={required}
        subtitle={subtitle}
        title={title}
      >
        {children}
      </ConcordeBlockHeading>
    )
  }

  const Heading = isGroup ? H5 : H6

  return (
    <>
      <div className={classes.contentContainer}>
        {title && (
          <div className={classes.titleContainer}>
            <Heading>
              <b className={mobile ? classes.smallFont : classes.bigFont}>
                {title}
              </b>
            </Heading>
          </div>
        )}
        {subtitle && (
          <div>
            <Typography variant="body1">{subtitle}</Typography>
          </div>
        )}
      </div>
      {children}
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  smallFont: {
    fontSize: '80%'
  },
  bigFont: {
    fontSize: '100%'
  },
  titleContainer: {
    paddingBottom: 0
  },
  contentContainer: {
    paddingBottom: theme.spacing(1)
  }
}))
